import { FormInstance } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import SelectComponent from 'components/atoms/SelectComponent';

import icoValidation from 'utils/validations/icoValidation';
import leiValidation from 'utils/validations/leiValidation';
import nidValidation from 'utils/validations/nidValidation';
import rodneCisloValidation from 'utils/validations/rodneCisloValidation';

interface IFsluzbyIdentifikace {
    form: FormInstance<any>;
    disabled: boolean;
    rerender: React.Dispatch<React.SetStateAction<boolean>>;
}

const FsluzbyIdentifikace: React.FC<IFsluzbyIdentifikace> = ({ form, disabled, rerender }) => {
    return (
        <>
            <SelectComponent
                labelParagraph="IDENTIFIKACE_TYP"
                data={
                    form.getFieldValue('octg') === '2'
                        ? [
                              {
                                  labelcz: 'ICO_ZKRATKA',
                                  value: 'ICO'
                              },
                              {
                                  labelcz: 'LEI_VELKE',
                                  value: 'LEI'
                              },
                              {
                                  labelcz: 'OSTATNI',
                                  value: 'OST'
                              }
                          ]
                        : [
                              {
                                  labelcz: 'FORMULARE_RODNE_CISLO',
                                  value: 'RC'
                              },
                              {
                                  labelcz: 'EMP_PODANE_ZADOSTI_NID',
                                  value: 'NID'
                              },
                              {
                                  labelcz: 'FORMULARE_DATUM_NAROZENI',
                                  value: 'DAT'
                              },
                              {
                                  labelcz: 'OSTATNI',
                                  value: 'OST'
                              }
                          ]
                }
                name="identifikace"
                onChange={() => {
                    form.setFieldsValue({
                        idmb: undefined
                    });
                    rerender(pv => !pv);
                }}
                isFormItem={true}
                disabled={disabled}
            />

            {form.getFieldValue('identifikace') === 'RC' && (
                <InputComponent
                    disabled={disabled}
                    label="FORMULARE_RODNE_CISLO"
                    name="idmb"
                    rules={rodneCisloValidation()}
                    maxLength={50}
                />
            )}
            {form.getFieldValue('identifikace') === 'NID' && (
                <InputComponent
                    disabled={disabled}
                    label="EMP_PODANE_ZADOSTI_NID"
                    name="idmb"
                    rules={nidValidation()}
                    maxLength={50}
                />
            )}
            {form.getFieldValue('identifikace') === 'DAT' && (
                <DatePickerComponent
                    disabled={disabled}
                    name="idmb"
                    label="FORMULARE_DATUM_NAROZENI"
                    disabledDate={current => current > dayjs()}
                />
            )}
            {form.getFieldValue('identifikace') === 'ICO' && (
                <InputComponent
                    disabled={disabled}
                    label="ICO_ZKRATKA"
                    name="idmb"
                    maxLength={30}
                    rules={icoValidation()}
                />
            )}
            {form.getFieldValue('identifikace') === 'LEI' && (
                <InputComponent
                    disabled={disabled}
                    label="LEI_VELKE"
                    name="idmb"
                    maxLength={20}
                    rules={leiValidation()}
                />
            )}
            {form.getFieldValue('identifikace') === 'OST' && (
                <InputComponent disabled={disabled} label="OSTATNI" name="idmb" maxLength={50} />
            )}
        </>
    );
};

export default FsluzbyIdentifikace;
